module.exports = __webpack_public_path__ + "img/e71be4ccdefeb3f24715b2cac2724203.png";